import { render, staticRenderFns } from "./MainLanding.vue?vue&type=template&id=2268ed98&scoped=true&"
import script from "./MainLanding.vue?vue&type=script&lang=js&"
export * from "./MainLanding.vue?vue&type=script&lang=js&"
import style0 from "./MainLanding.vue?vue&type=style&index=0&id=2268ed98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268ed98",
  null
  
)

export default component.exports